(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'slideShow', {
            bindings: {
                content:    '<'
            },
            templateUrl:  'app/views/partials/content/slide-show.html',
            controller:   SlideShowController,
            controllerAs: 'vm',

            renderingOptions: {
                'slide-show': {
                    inputs:        [ 'content="::content.asset_contents"' ],
                    classes:       [
                        'block-container',
                        'block__slide-show'
                    ],
                    wrapStart:     '<div class="centraliser">',
                    wrapEnd:       '</div>'
                }
            }
        });


    function SlideShowController( $scope, TEXTS ){
        // Helper members.

        /** @type {angular.IController} */
        var vm = this;

        /** Private attributes. */
        var maxPosition;


        /** Expose to the Scope. */

        $scope._ = TEXTS.GENERIC.SLIDE_SHOW;


        /** @constructor */
        vm.$onInit = function() {
            /** Expose to the API. */
            vm.current     = 0;

            vm.nextImage    = nextImage;
            vm.prevImage    = prevImage;
            vm.isFirstSlide = isFirstSlide;
            vm.isLastSlide  = isLastSlide;

            maxPosition = vm.content.images.length - 1;
        };


        /** Public methods. */

        function prevImage(){
            if ( !isFirstSlide() ) vm.current--;
        }

        function nextImage(){
            if ( !isLastSlide() ) vm.current++;
        }

        function isFirstSlide(){
            return vm.current === 0;
        }

        function isLastSlide(){
            return vm.current === maxPosition;
        }
    }


    SlideShowController.$inject = [ '$scope', 'TEXTS' ];
})();

